import alt from '../alt';


class CountryCodeActions {
    constructor() {
        this.generateActions('getCountryCodesSuccess');
    }

}

export default alt.createActions(CountryCodeActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/CountryCodeActions.js
 **/